module.exports = __webpack_public_path__ + "img/img.fa082a01.jpeg";